// import React, { useContext, useEffect } from 'react'
// import HomeNavBar from '../HomeComponent/HomeNavBar'
// import MailIcon from '../../SVG/MailIcon'
// import { HrStorage } from '../../Context/HrStore'

// const HrSection1 = () => {
//     let { setactive } = useContext(HrStorage)
//     useEffect(() => {
//         setactive('about')
//     }, [])
//     return (
//         <div className='relative ' >
//             <img src={require('../../Assest/cards/hrmback.avif')} className='absolute top-0 ' alt="Background" />
//             <HomeNavBar type='white' />
//             <main className='relative py-5 poppins ' >
//                 <h5 className='text-white text-2xl w-4/5 sm:text-6xl mx-auto  text-center fw-semibold ' >
//                     Smart HR Solutions  <br /> for a Smarter Workplace </h5>
//                 <p className='w-4/5 mx-auto text-sm sm:text-base text-slate-300 text-center ' >
//                     Change the way you manage recruitment, payroll, and employee engagement with our <br /> personalized HR
//                     services designed for every business need. </p>
//                 <section className='mx-auto shadow w-fit bg-white rounded-full ' >
//                     <div className='flex items-center gap-2 p-2 ps-4 ' >
//                         <MailIcon />
//                         <input type="text" className='outline-none w-40 ' placeholder='Enter your mail' />
//                         <button className='px-3 btngrd text-white rounded-full p-3 w-[10rem] h-full
//                         ' >
//                             Start for free
//                         </button>
//                     </div>
//                 </section>
//             </main>
//             <img src={require('../../Assest/cards/hrdash.avif')} alt="HrDashboard" className='relative px-0 container rounded-xl my-10 bg-red-500 ' />

//         </div>
//     )
// }

// export default HrSection1


import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles, ArrowRight, ShieldCheck, Cpu, Globe } from 'lucide-react';
import candidateImg from '../../Assest/cards/candidate.avif';

const AboutHero = () => {
    return (
        <section className="relative min-h-[90vh] bg-[#01014C] overflow-hidden flex items-center pt-20">
            {/* --- ANIMATED BACKGROUND ELEMENTS --- */}
            {/* Soft mesh glows */}
            <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-blue-600/20 blur-[150px] rounded-full -z-0" />
            <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-indigo-600/10 blur-[100px] rounded-full -z-0" />
            
            {/* Abstract Grid Infrastructure */}
            <div className="absolute inset-0 opacity-10 -z-0" 
                 style={{ backgroundImage: 'radial-gradient(#ffffff 1px, transparent 1px)', backgroundSize: '40px 40px' }} />

            <div className="container mx-auto px-6 relative z-10">
                <div className="flex flex-col lg:flex-row items-center gap-16">
                    
                    {/* LEFT CONTENT */}
                    <div className="lg:w-3/5 text-left">
                        <motion.div
                            initial={{ opacity: 0, x: -30 }}
                            animate={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.6 }}
                            className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/5 border border-white/10 text-blue-400 text-xs font-bold uppercase tracking-[0.2em] mb-8"
                        >
                            <Sparkles size={14} className="animate-pulse" />
                            Next-Gen HR Intelligence
                        </motion.div>

                        <motion.h1 
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.8, delay: 0.2 }}
                            className="text-white text-5xl md:text-6xl font-bold syne leading-[1.1] mb-8"
                        >
                            Building The Future Of <br />
                            <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-cyan-300">Workforce Growth</span>
                        </motion.h1>

                        <motion.p 
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.8, delay: 0.4 }}
                            className="text-blue-100/60 text-lg md:text-xl max-w-2xl leading-relaxed mb-12"
                        >
                            From startup hiring ecosystems to enterprise workforce operations, we leverage 
                            <span className="text-white font-semibold"> <a href="/blog/ai-powered-hr-consulting">AI-powered HR consulting </a> </span> 
                            to build stronger, faster, and more scalable foundations for your business.
                        </motion.p>

                        <motion.div 
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.8, delay: 0.6 }}
                            className="flex flex-wrap gap-6"
                        >
                            <button className="group relative px-8 py-3 bg-blue-600 text-white rounded-2xl font-bold flex items-center gap-3 transition-all hover:bg-blue-700 shadow-xl shadow-blue-900/40">
                                Book Strategy Consultation
                                <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
                            </button>
                            
                            <div className="flex items-center gap-4 px-6 py-3 rounded-2xl bg-white/5 border border-white/10 backdrop-blur-sm">
                                <div className="flex -space-x-3">
                                    {[1,2,3].map(i => (
                                        <div key={i} className="w-8 h-8 rounded-full border-2 border-[#01014C] bg-slate-400 overflow-hidden">
                                            <img src={`https://i.pravatar.cc/100?img=${i+10}`} alt="Expert" />
                                        </div>
                                    ))}
                                </div>
                                <span className="text-white/70 text-sm font-medium">Join 200+ Scaled Teams</span>
                            </div>
                        </motion.div>
                    </div>

                    {/* RIGHT VISUAL: AI CORE */}
                    <div className="lg:w-2/5 relative flex justify-center items-center">
                        <motion.div 
                            initial={{ scale: 0.8, opacity: 0 }}
                            animate={{ scale: 1, opacity: 1 }}
                            transition={{ duration: 1.2, ease: "easeOut" }}
                            className="relative w-[300px] h-[300px] md:w-[450px] md:h-[450px] lg:w-[480px] lg:h-[480px]"
                        >
                            {/* Animated Outer Rings */}
                            <motion.div 
                                animate={{ rotate: 360 }}
                                transition={{ duration: 20, repeat: Infinity, ease: "linear" }}
                                className="absolute inset-0 border-2 border-dashed border-blue-500/30 rounded-full"
                            />
                            <motion.div 
                                animate={{ rotate: -360 }}
                                transition={{ duration: 15, repeat: Infinity, ease: "linear" }}
                                className="absolute inset-8 md:inset-10 border border-blue-400/20 rounded-full"
                            />

                            {/* Floating Tech Icons around the core */}
                            <motion.div animate={{ y: [0, -15, 0] }} transition={{ duration: 4, repeat: Infinity }} className="absolute -top-4 left-1/2 -translate-x-1/2 p-4 bg-white/10 backdrop-blur-xl border border-white/20 rounded-2xl text-blue-400 shadow-2xl">
                                <Cpu size={24} />
                            </motion.div>
                            <motion.div animate={{ y: [0, 15, 0] }} transition={{ duration: 5, repeat: Infinity, delay: 1 }} className="absolute -bottom-4 left-1/2 -translate-x-1/2 p-4 bg-white/10 backdrop-blur-xl border border-white/20 rounded-2xl text-cyan-400 shadow-2xl">
                                <Globe size={24} />
                            </motion.div>
                            <motion.div animate={{ x: [0, 15, 0] }} transition={{ duration: 4.5, repeat: Infinity, delay: 0.5 }} className="absolute top-1/2 -right-8 -translate-y-1/2 p-4 bg-white/10 backdrop-blur-xl border border-white/20 rounded-2xl text-indigo-400 shadow-2xl">
                                <ShieldCheck size={24} />
                            </motion.div>

                            {/* Center Glass Core */}
                            <div className="absolute inset-[4.5rem] md:inset-[6.5rem] lg:inset-[7rem] bg-gradient-to-br from-blue-500 to-indigo-600 rounded-[2.5rem] shadow-[0_0_50px_rgba(37,99,235,0.5)] flex items-end justify-center pt-8 px-4 pb-0 overflow-hidden">
                                <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/carbon-fibre.png')] opacity-20" />
                                <img src={candidateImg} alt="Candidate" className="w-[120%] max-w-[120%] h-auto object-contain object-bottom z-10 translate-y-2 scale-110" />
                                {/* Animated scanning line */}
                                <motion.div 
                                    animate={{ top: ['0%', '100%', '0%'] }}
                                    transition={{ duration: 4, repeat: Infinity, ease: "linear" }}
                                    className="absolute left-0 right-0 h-[2px] bg-white/50 blur-[2px] z-20"
                                />
                            </div>
                        </motion.div>
                    </div>

                </div>
            </div>
        </section>
    );
};

export default AboutHero;